import CallIn from 'app/assets/images/PerformanceReport/CallIn.svg';
import CallOut from 'app/assets/images/PerformanceReport/CallOut.svg';
import CandidateContacted from 'app/assets/images/PerformanceReport/CandidateContacted.svg';
import MailOut from 'app/assets/images/PerformanceReport/MailOut.svg';
import MessageIn from 'app/assets/images/PerformanceReport/MessageIn.svg';
import MessageOut from 'app/assets/images/PerformanceReport/MessageOut.svg';
import OpenRate from 'app/assets/images/PerformanceReport/OpenRate.svg';
import SpokeToCandidate from 'app/assets/images/PerformanceReport/SpokeToCandidate.svg';
import { kFormatter } from 'app/helpers/numberHelper';
import React from 'react';
import { customSwitch } from 'utils/customSwitchCase/customSwitch';
import { NotificationMetric } from './Tile';

export const getNotificationKpiTileIcon = customSwitch({
  [NotificationMetric.CallIn]: <img src={CallIn} alt="Call in" />,
  [NotificationMetric.CallOut]: <img src={CallOut} alt="Call out" />,
  [NotificationMetric.SpokeToCandidate]: <img src={SpokeToCandidate} alt="Spoke to candidate" />,
  [NotificationMetric.CandidateContacted]: <img src={CandidateContacted} alt="Candidate contacted" />,
  [NotificationMetric.EmailSent]: <img src={MailOut} alt="Mail out" />,
  [NotificationMetric.OpenRate]: <img src={OpenRate} alt="Open Rate" />,
  [NotificationMetric.MessageIn]: <img src={MessageIn} alt="Message In" />,
  [NotificationMetric.MessageOut]: <img src={MessageOut} alt="Message out" />,
})(undefined);

export const getNotificationGridTitle = customSwitch({
  [NotificationMetric.CallIn]: 'Inbound Call',
  [NotificationMetric.CallOut]: 'Outbound Call',
  [NotificationMetric.SpokeToCandidate]: 'Spoke W/ Candidate',
  [NotificationMetric.CandidateContacted]: 'Candidates Contacte',
  [NotificationMetric.EmailSent]: 'Outbound Email',
  [NotificationMetric.OpenRate]: 'Open Rate',
  [NotificationMetric.MessageIn]: 'Inbound Messages',
  [NotificationMetric.MessageOut]: 'Outbound Messages',
})(undefined);

export const getNotificationMetricChannel = customSwitch({
  [NotificationMetric.CallIn]: 'Voice',
  [NotificationMetric.CallOut]: 'Voice',
  [NotificationMetric.EmailSent]: 'Email',
  [NotificationMetric.MessageIn]: 'Conversation',
  [NotificationMetric.MessageOut]: 'Conversation',
})(undefined);

export const flattenedNotificationTileData = NotificationMetricsValue => {
  const voiceKpi = NotificationMetricsValue && NotificationMetricsValue.find(kpi => kpi.channel === 'Voice')?.kpis;
  const emailKpi = NotificationMetricsValue && NotificationMetricsValue.find(kpi => kpi.channel === 'Email')?.kpis;
  const smsKpi = NotificationMetricsValue && NotificationMetricsValue.find(kpi => kpi.channel === 'SMS')?.kpis;

  return [
    {
      primaryLabel: NotificationMetric.CallIn,
      secondaryLabel: '',
      value: kFormatter(
        voiceKpi && voiceKpi.find(kpi => kpi.name === 'Inbound count')?.count,
        voiceKpi && voiceKpi.find(kpi => kpi.name === 'Inbound count')?.count > 10000 ? 0 : 1,
      ),
      showProgress: false,
      isSelected: false,
    },
    {
      primaryLabel: NotificationMetric.CallOut,
      secondaryLabel: '',
      value: kFormatter(
        voiceKpi && voiceKpi.find(kpi => kpi.name === 'Outbound count')?.count,
        voiceKpi && voiceKpi.find(kpi => kpi.name === 'Outbound count')?.count > 10000 ? 0 : 1,
      ),
      showProgress: false,
    },
    {
      primaryLabel: NotificationMetric.SpokeToCandidate,
      secondaryLabel: '%',
      value: Math.round((voiceKpi && voiceKpi.find(kpi => kpi.name === 'Call Spoken Rate(%)')?.rate) ?? 0),
      showProgress: true,
      disabled: false,
    },

    {
      primaryLabel: NotificationMetric.EmailSent,
      secondaryLabel: '',
      value: kFormatter(
        emailKpi && emailKpi.find(kpi => kpi.name === 'Outbound count')?.count,
        emailKpi && emailKpi.find(kpi => kpi.name === 'Outbound count')?.count > 10000 ? 0 : 1,
      ),
      showProgress: false,
    },
    {
      primaryLabel: NotificationMetric.OpenRate,
      secondaryLabel: '%',
      value: Math.round((emailKpi && emailKpi.find(kpi => kpi.name === 'Email Open Rate(%)')?.rate) ?? 0),
      showProgress: true,
      disabled: false,
    },
    {
      primaryLabel: NotificationMetric.MessageIn,
      secondaryLabel: '',
      value: kFormatter(
        smsKpi && smsKpi.find(kpi => kpi.name === 'Inbound count')?.count,
        smsKpi && smsKpi.find(kpi => kpi.name === 'Inbound count')?.count > 10000 ? 0 : 1,
      ),
      showProgress: false,
    },
    {
      primaryLabel: NotificationMetric.MessageOut,
      secondaryLabel: '',
      value: kFormatter(
        smsKpi && smsKpi.find(kpi => kpi.name === 'Outbound count')?.count,
        smsKpi && smsKpi.find(kpi => kpi.name === 'Outbound count')?.count > 10000 ? 0 : 1,
      ),
      showProgress: false,
    },
  ];
};
